module.exports = __webpack_public_path__ + "static/media/www3.5b23a2ad.svg";